// contexts/ProjectContext.tsx
'use client';

import React, { createContext, useContext, useState } from 'react';
import { ProjectContextType, Project } from '@/types/projectContextType';

// Valeurs par défaut sûres (fallbacks)
const defaultContext: ProjectContextType = {
  project: null,
  setProject: () => {},
  projects: [],
  setProjects: () => {},
};

// Création du contexte avec valeurs par défaut
const ProjectContext = createContext<ProjectContextType>(defaultContext);

export const ProjectProvider = ({ children }: { children: React.ReactNode }) => {
  const [project, setProject] = useState<Project | null>(null);
  const [projects, setProjects] = useState<Project[]>([]);

  return (
    <ProjectContext.Provider value={{ project, setProject, projects, setProjects }}>
      {children}
    </ProjectContext.Provider>
  );
};

export const useProject = () => useContext(ProjectContext);
